<app-closeable-dialog-title title="Academic Database Overview"></app-closeable-dialog-title>
<mat-dialog-content>
  <div class="db-overview">
    <p>
      Our platform integrates with several academic databases that provide access to a wealth of peer-reviewed
      literature,
      abstracts, and research articles. Whether you are looking for biomedical studies, comprehensive scientific
      literature,
      or AI-powered research tools, these databases are essential for finding reliable and up-to-date
      information.
      Use the toggles below to enable or disable queries for each database.
      If an API key is required and not set up, a warning will be displayed along with an option to update your
      settings.
    </p>
    <app-info-card
      [marginTop]="true"
      title="API keys"
      link="/documentation/help"
    >
              <span subtitle>
              An API key for databases like PubMed or Semantic Scholar is a special code provided by those databases. It
              identifies and authenticates your application, letting you safely and efficiently access their research
              articles and data. Without this key, you might face restrictions or limited functionality when searching
              their content.
              </span>
    </app-info-card>
  </div>
</mat-dialog-content>
